module.exports = __webpack_public_path__ + "img/goldregen-2020-107.59e3c2c8.jpg";